module.exports = __webpack_public_path__ + "img/scacThumpUpAnimation.21eaab54.svg";